import React from "react"
import { StaticQuery, graphql, Link } from "gatsby"
import styles from "./slider.module.scss"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import Img from "gatsby-image"

export default () => {
  return (
    <StaticQuery
      query={graphql`
        query {
          data: allFile(filter: { absolutePath: { regex: "/slider/" } }) {
            edges {
              node {
                childImageSharp {
                  fluid {
                    ...GatsbyImageSharpFluid_withWebp
                  }
                }
              }
            }
          }
        }
      `}
      render={data => {
        return (
          <div className="row">
            <div className="col-lg-12" style={{ height: "100vh" }}>
              <div className={styles.slider}>
                {data.data.edges.map(photo => {
                  return (
                    <div
                      key={photo.node.childImageSharp.fluid.src}
                      className={styles.photo}
                    >
                      <Img
                        key={photo.node.childImageSharp.fluid.src}
                        fluid={photo.node.childImageSharp.fluid}
                        style={{ height: "100vh" }}
                      />
                    </div>
                  )
                })}
              </div>
              <div className={styles.content}>
                <span className={styles.pre}>
                  Ciblez vos clients par géolocalisaiton
                </span>
                <h1 className={styles.h1}>
                  Diffusez vos <strong>publicitées</strong>
                  <br /> dans les <strong>taxis</strong>
                </h1>
                <p className={styles.p}>
                  Letitan Media, première{" "}
                  <strong>plateforme de publicité mobile</strong>
                  Algérienne, est un média embarqué dédié à la diffusion
                  <strong>d’annonces publicitaire </strong> s et au
                  divertissement via un réseau de{" "}
                  <strong>tablettes embarquées</strong> dans les{" "}
                  <strong>taxis</strong> à Alger et dans d’autres grandes villes
                  d’Algérie.
                </p>
              </div>
            </div>
          </div>
        )
      }}
    />
  )
}
